module.exports = __webpack_public_path__ + "static/media/guide_step_2.65a30cef.png";